import ResponseObject = Wollmilch.ResponseObject;

class ObjectManager
{
	private ObjectList: SPA.Realtor.ObjectList;

	private limit: number;

	private page: number;

	private working: boolean;

	private LastModified: Date;

	private Observers: Array<(data: Wollmilch.Realtor.Object[]) => any>;

	private Listener: Backbone.Events;

	public constructor(limit: number = 50, page: number = 0)
	{
		this.limit = limit;
		this.page = page;
		this.working = false;
		this.LastModified = new Date(0);
		this.Observers = [];
		this.ObjectList = new SPA.Realtor.ObjectList();

		this.Listener = Backbone.Events;
	}

	public reset(limit: number = 50, page: number = 0)
	{
		this.limit = limit;
		this.page = page;
		this.working = false;
		this.LastModified = new Date(0);
		this.Observers = [];
	}

	public getLastModified(): Date
	{
		return this.LastModified;
	}

	public getData(ObjectNumber: string): SPA.Realtor.RealtorObjectModel
	{
		const result = this.ObjectList.get(ObjectNumber);
		return result;
	}
	public addItem(object: SPA.Realtor.RealtorObjectModel): void
	{
		this.ObjectList.add(object);
	}

	public filter(ObjectNumber: string): SPA.Realtor.RealtorObjectModel[]
	{
		const result = this.ObjectList.where({ObjectNumber});
		return result;
	}

	public getList(): SPA.Realtor.ObjectList
	{
		return this.ObjectList;
	}

	public Count(): number
	{
		return this.ObjectList.length;
	}

	public delete(object_number: string, callback?: (data: any) => void)
	{
		new Wollmilch.AJAX({
			url: 'object/delete/' + btoa(object_number),
			data: [],
			method: 'DELETE',
			on: {
				success: (text) => {
					const res = Wollmilch.jsonize(text);
					if (!res || res.success === false) {
						alert("Fehler beim Löschen des Objektes");
						return;
					}

					// Backbone
					this.ObjectList.remove(object_number);

					app.addNotify(
						{
							body: ['Das Objekt wurde erfolgreich gelöscht.'],
							context: 'success',
							title: ['Objekt gelöscht'],
							timeout: Number(app.getConfigValue("ToastTimeout"))
						}
					);

					if (callback)
					{
						callback(res.success);
					}
				}
			}
		}, AJAXCallbase_e.REALTOR).send();
	}

	public buildLink(object: SPA.Realtor.RealtorObjectModel): JQuery
	{
		const link = ui.$$.a();
		link.addClass('link')
			.append(`<span>${object.ObjectNumber}</span>`);

		link.on('click', () => {
			app.getGlobalTabControl().addTab(
				object.ObjectNumber,
				new SPA.Realtor.Page(object),
				true
			);
		});

		return link;
	}

	public saveExposeText(object_number: string, data: { [key: string]: string } = {}): void
	{
		if (data === {}) {
			return;
		}

		new Wollmilch.AJAX({
			url: 'object/update/' + btoa(object_number) + '/expose',
			data: JSON.stringify(data),
			method: 'PATCH',
			on:
				{
					success: (text: string): void => {
						let obj: Wollmilch.ResponseObject | null;

						try {
							obj = Wollmilch.jsonize(text);
						} catch (e) {
							app.addNotify(
								{
									title: ['Speichervorgang fehlgeschlagen'],
									body: ['Beim speichern der Objektdaten ist ein Fehler aufgetreten.'],
									context: 'warning',
									timeout: Number(app.getConfigValue("ToastTimeout"))
								}
							);

							return;
						}

						if (obj !== null && obj.success) {
							app.addNotify({
								title: ['Speichervorgang'],
								body: ['Die Objektdaten wurden erfolgreich gespeichert.'],
								context: 'success',
								timeout: Number(app.getConfigValue("ToastTimeout"))
							});
							this.updateData(object_number, data);
						}
					}
				}
		}, AJAXCallbase_e.REALTOR).send();
	}

	public saveMoreData(object_number: string, data: { [key: string]: string } = {}, callback?: (data: any) => void): void
	{
		if (data === {}) {
			return;
		}

		new Wollmilch.AJAX({
			url: 'object/update/' + btoa(object_number) + '/adv_data',
			data: JSON.stringify(data),
			method: 'PATCH',
			on:
				{
					success: (text: string): void => {
						let obj: Wollmilch.ResponseObject | null;

						try {
							obj = Wollmilch.jsonize(text);
						} catch (e) {
							app.addNotify(
								{
									title: [ui.h(3, app.getMessage('Realtor.List.ERROR_LIST'))],
									body: [ui.text(app.getMessage('Realtor.List.ERROR_LIST_TEXT'))],
									context: 'warning',
									timeout: Number(app.getConfigValue("ToastTimeout"))
								}
							);

							return;
						}

						if (obj !== null && obj.success)
						{
							app.addNotify({
								title: ['Speichervorgang'],
								body: ['Die Objektdaten wurden erfolgreich gespeichert.'],
								context: 'success',
								timeout: Number(app.getConfigValue("ToastTimeout"))
							});

							// Todo Use fresh data from server?
							this.updateData(object_number, obj.data.object);

							if  (callback)
							{
								callback(obj.data);
							}
						}
					}
				}
		}, AJAXCallbase_e.REALTOR).send();
	}

	public resolveAddress(search: any, callback: any)
	{
		new Wollmilch.AJAX({
			url: 'tools/resolve/input/' + search,
			method: 'GET',
			on: {
				success: (text: string) => {
					const obj = Wollmilch.jsonize(text);

					if (!obj || obj.success === false) {
						return;
					}

					callback(obj);
				}
			}

		}, AJAXCallbase_e.ROOT).send();
	}

	/**
	 * Outdated
	 * @param callback
	 * @param force
	 */
	public requestData(callback: ((data: SPA.Realtor.RealtorObjectModel[]) => any) | null = null, force: boolean = false)
	{
		this.ObjectList.fetch();
		return;
	}

	private updateData(object_number: string, data: any)
	{
		const newObject = new SPA.Realtor.RealtorObjectModel(data);
		this.ObjectList.add(newObject, {merge: true});
	}

	// private processListener()
	// {
	// 	while (this.Observers.length > 0) {
	// 		const cbFunc = this.Observers.shift();

	// 		if (cbFunc)
	// 		{
	// 			cbFunc(this.objectList);
	// 		}
	// 	}
	// }
}
